import { ethers } from "ethers";
import { getMulticallContract } from "./IgetContracts";
//import { MultiCallResponse } from './types';
// @ts-ignore
import getNodeUrl from "../utils/getRpcUrl.js";

export interface Call {
  address: string; // Address of the contract
  name: string; // Function name on the contract (example: balanceOf)
  params?: any[]; // Function params
}

// var rpc = getNodeUrl();

// Initialize a new provider with the custom RPC URL
// const provider = new ethers.providers.JsonRpcProvider(rpc);

interface MulticallOptions {
  requireSuccess?: boolean;
}

const multicall = async <T = any>(abi: any[], calls: Call[]) => {
  // console.log("MULTICALL")
  // console.log("MULTICALL calls", calls)
  const callholder = calls;
  console.log(calls);
  try {
    const multi = getMulticallContract();
    const itf = new ethers.utils.Interface(abi);

    const calldata = calls.map((call: any) => [
      call.address.toLowerCase(),
      itf.encodeFunctionData(call.name, call.params),
    ]);

    const { returnData } = await multi.aggregate(calldata);

    const res = returnData.map((call: any, i: any) =>
      itf.decodeFunctionResult(calls[i].name, call)
    );

    return res;
  } catch (error) {
    console.log(error);
    //   console.error('Multicall error: ', error);
    // console.error('Multicall error calls: ', callholder);
    //throw new Error(error);
  }
};

/**
 * Multicall V2 uses the new "tryAggregate" function. It is different in 2 ways
 *
 * 1. If "requireSuccess" is false multicall will not bail out if one of the calls fails
 * 2. The return inclues a boolean whether the call was successful e.g. [wasSuccessfull, callResult]
 */
export const multicallv2 = async <T = any>(
  abi: any[],
  calls: Call[],
  options: MulticallOptions = { requireSuccess: true }
) => {
  const { requireSuccess } = options;
  const multi = getMulticallContract();
  const itf = new ethers.utils.Interface(abi);

  const calldata = calls.map((call: any) => [
    call.address.toLowerCase(),
    itf.encodeFunctionData(call.name, call.params),
  ]);
  const returnData = await multi.tryAggregate(requireSuccess, calldata);
  const res = returnData.map((call: any, i: any) => {
    const [result, data] = call;
    return result ? itf.decodeFunctionResult(calls[i].name, data) : null;
  });

  return res;
};

export default multicall;
